import { useTranslation } from 'react-i18next'

export default function FeaturedResponseBubble() {
  const { t } = useTranslation()
  return (
    <div
      style={{
        background: 'linear-gradient(135deg, rgba(124,58,237,0.22) 0%, rgba(76,29,149,0.32) 100%)',
        border: '1px solid rgba(167,139,250,0.35)',
        borderRadius: '22px',
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        boxShadow: '0 0 60px rgba(124,58,237,0.3), 0 8px 32px rgba(0,0,0,0.5), inset 0 1px 0 rgba(196,181,253,0.2)',
        padding: '24px',
      }}
    >
      <div
        style={{
          height: '1px',
          background: 'linear-gradient(90deg, transparent, rgba(196,181,253,0.5), transparent)',
          marginBottom: '18px',
        }}
      />
      <div className="flex items-center gap-3 mb-4">
        <div
          style={{
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            background: 'radial-gradient(circle at 30% 30%, #e9d5ff, #7c3aed 55%, #2e1065)',
            boxShadow: '0 0 22px rgba(124,58,237,0.9), 0 0 6px rgba(233,213,255,0.5)',
            position: 'relative',
            flexShrink: 0,
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '7px',
              width: '7px',
              height: '7px',
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.85)',
              filter: 'blur(2px)',
            }}
          />
        </div>
        <div>
          <p className="font-headline font-bold text-white text-sm">{t('home.response.brand')}</p>
          <p className="text-[#a78bfa]/70 text-xs">{t('home.response.label')}</p>
        </div>
        <span className="ml-auto shrink-0 font-headline text-[10px] font-bold uppercase tracking-wide text-[#a78bfa] bg-[#7c3aed]/20 px-2.5 py-0.5 rounded-full border border-[#7c3aed]/30">
          {t('home.response.badge')}
        </span>
      </div>
      <p className="text-white/85 text-sm leading-relaxed font-medium mb-4">
        "{t('home.response.quote')}"
      </p>
      <div className="flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-[#4cd7f6] shrink-0" style={{ boxShadow: '0 0 6px rgba(76,215,246,0.8)' }} />
        <p className="text-white/60 text-xs font-headline">{t('home.response.tags')}</p>
      </div>
    </div>
  )
}
